import React from 'react';
import CursorClickIcon from '@heroicons/react/outline/CursorClickIcon.js';
import { BlockType } from '../../types/index.js';
import { CallToActionBlock as Component } from './Block.js';
import { CallToActionBlockSettings as Settings } from './Settings.js';
export const RegisteredCallToActionBlock = (intl) => {
    const { $t } = intl;
    return {
        recommendedName: 'CallToAction',
        Component,
        config: {
            type: BlockType.Block,
            usable: true,
            displayName: $t({
                id: 'Blocks.CallToAction.displayName',
                defaultMessage: 'Call to action',
            }),
            Settings,
            Icon: React.createElement(CursorClickIcon, null),
            defaultProps: {
                alignment: 'left',
                title: $t({
                    id: 'Blocks.CallToAction.DefaultTitle',
                    defaultMessage: 'Call to action',
                }),
                description: $t({
                    id: 'Blocks.CallToAction.DefaultDescription',
                    defaultMessage: 'Attention, everyone. This is a call to action for you to take action on the very actionable call to action button below, which reads “call to action”.',
                }),
                action: {
                    type: 'button',
                    text: $t({
                        id: 'Blocks.CallToAction.DefaultActionText',
                        defaultMessage: 'Call to action',
                    }),
                    href: '#',
                },
            },
        },
    };
};
//# sourceMappingURL=registered.js.map